import { InputSearch } from "./inputsearch";
import { Stationselect } from "./select";

function StationPicker(props: any) {
  return (
    <div>
      {props.useinputsearch ? (
        <InputSearch type={props.type} />
      ) : (
        <Stationselect type={props.type} />
      )}
    </div>
  );
}
export default StationPicker;
